import { memo, useMemo } from 'react'
import {
  useConvertBaseToken,
  useConvertQuoteToken,
  useCurrentConvertInfo,
} from 'store/convert/hooks'
import { ExchangeInfoWrap, ExchangeInfoItem } from './style'
import Decimal from 'decimal.js'

export const ExchangeInfo = memo(() => {
  const { token: baseSymbol } = useConvertBaseToken()
  const { token: quoteSymbol } = useConvertQuoteToken()
  const {
    quoteAmount: currentQuoteAmount,
    price: convertCurrentPrice,
    feeRate,
  } = useCurrentConvertInfo()

  const fee = useMemo(() => {
    if (!currentQuoteAmount || !feeRate) return ''
    return Decimal.mul(currentQuoteAmount, feeRate).toFixed()
  }, [currentQuoteAmount, feeRate])

  const receiveFactAmount = useMemo(() => {
    if (!currentQuoteAmount) return ''
    return Decimal.sub(currentQuoteAmount, fee).toFixed()
  }, [currentQuoteAmount, fee])

  return (
    <ExchangeInfoWrap>
      <ExchangeInfoItem>
        <div className="left">Rate</div>
        <div className="right">
          {!convertCurrentPrice || !quoteSymbol?.name
            ? '--'
            : `1 ${baseSymbol?.name}= ${
                convertCurrentPrice || '0'
              } ${quoteSymbol?.name}`}
        </div>
      </ExchangeInfoItem>
      <ExchangeInfoItem>
        <div className="left">You will receive</div>
        <div className="right">
          {!receiveFactAmount || !quoteSymbol?.name
            ? '--'
            : `${receiveFactAmount} ${quoteSymbol?.name}`}
        </div>
      </ExchangeInfoItem>
    </ExchangeInfoWrap>
  )
})
